import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ProvisionImpairmentDetail } from './ProvisionImpairmentDetail/ProvisionImpairmentDetail'
import { ProvisionImpairmentForm } from './ProvisionImpairmentForm/ProvisionImpairmentForm'
import { ProvisionImpairmentMain } from './ProvisionImpairmentMain'

const provisionImpairmentRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment',
    },
    component: <ProvisionImpairmentMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/add',
    },
    component: (
      <ProvisionImpairmentForm fromMode="add" type="ASSETS_REGISTRATION" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/:ProvisionImpairmentID/edit',
    },
    component: <ProvisionImpairmentForm fromMode="edit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/:ProvisionImpairmentID/detail',
    },
    component: <ProvisionImpairmentDetail />,
  },
]

export default provisionImpairmentRoutes
